module.exports = __webpack_public_path__ + "static/media/Dance.298dd097.JPG";